var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordPayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1158_13488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9A62E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1158_13488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0592 8.17922C15.474 8.16305 17.4845 10.1305 17.5061 12.5399C17.5276 15.0032 15.5387 17.0192 13.0861 17.03C10.6767 17.0408 8.6769 15.0571 8.66612 12.6423C8.64994 10.179 10.6012 8.19539 13.0592 8.17383V8.17922Z",
    fill: "url(#paint0_linear_1158_13488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1848 7.49985C5.82107 7.43517 4.50585 7.23573 3.28227 6.61585C2.94808 6.44337 2.62467 6.21698 2.36054 5.94746C1.87003 5.45156 1.89698 4.96644 2.3875 4.46515C2.84027 3.9962 3.41164 3.71591 4.01534 3.52186C6.26846 2.79418 8.51079 2.80496 10.7208 3.67818C11.1412 3.84528 11.5455 4.1094 11.8905 4.40047C12.4888 4.90715 12.478 5.49469 11.9066 6.03371C11.2436 6.66436 10.4082 6.977 9.53494 7.15487C8.75874 7.31658 7.96638 7.38126 7.17941 7.49446L7.1848 7.49985Z",
    fill: "url(#paint1_linear_1158_13488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45112 8.85592C8.17622 9.34104 7.92827 9.79921 7.66415 10.2466C7.62641 10.3059 7.53478 10.3706 7.46471 10.376C5.99857 10.4083 4.57555 10.2197 3.24955 9.54587C3.0016 9.41651 2.76443 9.26019 2.54882 9.08231C2.04753 8.65649 1.94512 8.32229 2.04753 7.62695C4.03652 8.80741 6.20339 9.02841 8.44573 8.86131L8.45112 8.85592Z",
    fill: "url(#paint2_linear_1158_13488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37394 16.2263C8.00202 16.2478 7.65704 16.2856 7.30668 16.2856C6.02919 16.2856 4.77327 16.1293 3.59281 15.6118C3.29096 15.477 3.00528 15.3046 2.72499 15.1267C2.15901 14.7548 1.89489 14.2373 2.03504 13.5527C2.44469 13.7468 2.84896 13.9678 3.27479 14.1349C4.56844 14.6416 5.916 14.8356 7.2959 14.8033C7.5169 14.8033 7.6247 14.8626 7.72712 15.0728C7.91038 15.4609 8.13677 15.822 8.36855 16.2317L8.37394 16.2263Z",
    fill: "url(#paint3_linear_1158_13488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04734 10.5659C3.63746 11.5362 5.3785 11.838 7.19501 11.8596V13.3365C6.39726 13.3365 5.61567 13.2557 4.83948 13.067C4.07946 12.8891 3.35717 12.625 2.71573 12.1668C2.16593 11.7787 1.89642 11.2721 2.04734 10.5605V10.5659Z",
    fill: "url(#paint4_linear_1158_13488)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1158_13488",
    x1: 13.0861,
    y1: 8.17383,
    x2: 13.0861,
    y2: 17.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1158_13488",
    x1: 7.17152,
    y1: 2.99805,
    x2: 7.17152,
    y2: 7.49985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1158_13488",
    x1: 5.23142,
    y1: 7.62695,
    x2: 5.23142,
    y2: 10.3794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1158_13488",
    x1: 5.18599,
    y1: 13.5527,
    x2: 5.18599,
    y2: 16.2856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1158_13488",
    x1: 4.60043,
    y1: 10.5605,
    x2: 4.60043,
    y2: 13.3365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordPayment);
export default __webpack_public_path__ + "static/media/record_payment.43496aa4646fa60284a87af9236ab097.svg";
export { ForwardRef as ReactComponent };